<script lang="ts">
  import { t } from '$core/i18n';
  import { Icon } from '$ui/primitives/Icon';
  import { Avatar } from '$ui/primitives/Avatar';

  let {
    title,
    onOpenMenu,
    user = { name: 'User', avatarUrl: null },
    hideUser = false
  }: {
    title: string;
    onOpenMenu: () => void;
    user?: { name: string; avatarUrl?: string | null };
    hideUser?: boolean;
  } = $props();
</script>

<header class="topbar">
  <div class="topbar-left">
    <button
      type="button"
      class="icon-btn"
      aria-label={t('shell.mobile.openMenu')}
      onclick={onOpenMenu}
    >
      <Icon name="menu" size={20} />
    </button>
    <h1 class="title">{title}</h1>
  </div>
  {#if !hideUser}
    <div class="topbar-right">
      <div class="user-badge">
        <span class="user-name">{user.name}</span>
        <Avatar src={user.avatarUrl} name={user.name} size="sm" />
      </div>
    </div>
  {/if}
</header>

<style>
  .topbar {
    position: sticky;
    top: 0;
    z-index: var(--z-sticky);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    height: 56px;
    padding: 0 var(--space-6);
    background: var(--color-surface);
    border-bottom: var(--border-width) solid var(--color-border);
  }

  .topbar-left {
    display: flex;
    align-items: center;
    gap: var(--space-3);
  }

  .topbar-right {
    display: flex;
    align-items: center;
  }

  .user-badge {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: 4px 4px 4px 12px;
    background: var(--color-surface-sunken);
    border: var(--border-width) solid var(--color-border);
    border-radius: var(--radius-full);
  }

  .user-name {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--color-text-primary);
  }

  .icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: var(--radius-md);
    color: var(--color-text-primary);
    cursor: pointer;
    transition: background var(--dur-fast) var(--ease-out);
  }

  .icon-btn:hover {
    background: var(--color-surface-hover);
  }

  .icon-btn:focus-visible {
    outline: var(--focus-ring-width) solid var(--color-focus-ring);
    outline-offset: 2px;
  }

  .title {
    margin: 0;
    font-family: var(--font-display);
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: var(--color-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


</style>